class UserPreferences {
  constructor({ highContrastMode = false } = {}) {
    this.highContrastMode = highContrastMode;
  }

  static create({ highContrastMode = false } = {}) {
    return new UserPreferences({ highContrastMode });
  }
}

export default UserPreferences;
